<template lang="pug">
  .page
    payfast-form(:paymentParams="paymentParams")
    section
      b-container
        b-button(:to="{name: 'AccountOrders'}")
            font-awesome-icon.mr-2(icon="caret-left")
            span ALL ORDERS
        content-loader(:height="7", v-if="alert.loading")
        section(v-else-if="order")
          .container
            .row
              .col-md-6
                ul.list-unstyled
                  li
                    span.font-weight-bold ORDER
                    span.ml-1 {{ `#${order.id}` }}
                  li
                    span.font-weight-bold.mr-1 STATUS
                    b-badge {{ order.status.toUpperCase() }}
                  li
                    span.font-weight-bold SUB TOTAL
                    span.ml-1 {{ formatRandsCents(order.sub_total) }}
                  li
                    span.font-weight-bold SHIPPING
                    span.ml-1 {{ formatRandsCents(order.shipping_cost) }}
                  li
                    span.font-weight-bold VAT
                    span.ml-1 (included)
                  li.pt-3
                    span.font-weight-bold TOTAL
                    span.ml-1 {{ formatRandsCents(order.total) }}
                  li.pt-3
                    a.ml-1.text-primary(:href="order.invoice_url", target="_blank")
                      i.fa.fa-file-invoice-dollar.mr-2
                      span VIEW INVOICE
                div.d-inline(v-if="order.status === 'pending'")
                  b-button.btn-outline.mr-2(@click="completeOrder") COMPLETE ORDER
                button-load(v-if="['pending', 'paid'].includes(order.status)", :flag="alert.busy", label="CANCEL", classes="btn-outline", @clicked="cancelOrder()")
                form(v-if="pfParams", :action="payfast_url", ref='payfastForm')
                  input(v-for="(value, name, index) in pfParams", :key="index", :name="name", type='hidden', :value="value")
                // b-button.btn-outline.ml-3(v-if="order.status === 'pending'") CANCEL
              .col-md-6
                p Please note that orders containing items from multiple artists, will be dispatched as separate shipments
              .col-12
                hr
                h2 ITEMS
                div(v-if="order.lines.length > 0", v-for="line in order.lines", :key="line.id")
                  h4.m-0.mr-1.d-inline {{ `${order.type.toUpperCase()} of ${line.art_title}` }}
                  p {{ line.artist_name }}
                  .row
                    .col-12.col-md-11
                      ul.list-unstyled
                        li
                          span.font-weight-bold LINE REF
                          span.ml-1 {{ `#${line.id}` }}
                        li
                          span.font-weight-bold LINE STATUS
                          span.ml-1
                            b-badge(:variant="order.shipment_status==='completed'?'dark':'light'") {{ line.status.toUpperCase() }}

                        div(v-if="line.shipment")
                          //li
                            span.font-weight-bold SHIPMENT STATUS
                            b-badge(:variant="order.shipment_status==='completed'?'dark':'light'") {{ line.shipment.status.toUpperCase() }}
                          li.pt-3
                            a.text-primary(:href="`https://optimise.parcelninja.com/shipment/track/${line.shipment.tracking_number}`", target="_blank")
                              i.fa.fa-external-link-alt.mr-2
                              span {{ line.shipment.tracking_number ? `TRACK ${line.shipment.tracking_number}` : 'TRACKING N/A'}}
                    .col-12.col-md-1.text-right
                      a.text-primary(@click="getOrder()")
                        font-awesome-icon(icon="redo")
                  hr(v-if="order.lines.length > 1")
            // b-button.btn-outline(v-if="order.status === 'pending'") COMPLETE ORDER
        p(v-else="") Order not found
</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';
import router from '@/router';
import PayfastForm from '@/components/widgets/PayfastForm';

export default {
  name: 'Order',
  mixins: [standardMix],
  components: { PayfastForm },
  data() {
    return {
      orderId: '',
      order: null,
      fields: [
        { key: 'compTitle', label: 'Item', sortable: true },
        { key: 'compCarrier', label: 'Carrier' },
        { key: 'compTracking', label: 'Track' },
        { key: 'compStatus', label: 'Status' },
        // { key: 'compShipment', label: 'Shipment' },
        // { key: 'shipment_eta', label: 'ETA' },
        // { key: 'actions', label: '' },
      ],
      paymentParams: {},
      pfParams: null,
    };
  },
  computed: {
  },
  methods: {
    async getOrder() {
      try {
        const order = await apiService.getOrder(this.$route.params.orderId);
        if (this.order) {
          this.order = order;
          this.success('Status refreshed');
        } else {
          this.order = order;
        }
      } catch (error) {
        router.push('/account/orders');
        this.error('Order not found');
      }
    },
    async completeOrder() {
      if (process.env.NODE_ENV === 'production') {
        // setTimeout to put this into event queue after component render
        setTimeout(() => {
          // Create signature from parameters
          const signature = this.makeSignature(this.pfParams);
          this.pfParams.signature = signature;
          this.$refs.payfastForm.submit();
        }, 10);
      } else {
        router.push('/order-ok');
      }
    },
    async cancelOrder() {
      try {
        this.busy();
        await apiService.cancelOrder(this.profileId, this.order.id);
        this.order.status = 'cancelled';
        this.success('Order cancelled');
      } catch (error) {
        this.error('Could not cancel order');
      }
    },
  },
  async created() {
    if (this.$route.params.orderId) {
      this.loading();
      this.orderId = this.$route.params.orderId;
      await this.getOrder(this.orderId);
      this.clear();
      // Prepare payfast form for pending orders
      if (this.order.status === 'pending') {
        // const total = this.order.total;
        // console.log({ total });
        // const amount = total.parse.toFixed(2);
        // console.log({ amount });
        // Setup PayFast parameterfs
        this.pfParams = {
          merchant_id: process.env.VUE_APP_MERCHANT_ID,
          merchant_key: process.env.VUE_APP_MERCHANT_KEY,
          return_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-ok`,
          cancel_url: `${process.env.VUE_APP_CLIENT_BASE_URL}/order-not-ok`,
          notify_url: `${process.env.ROOT_API}/payment/payfast/itn`,
          name_first: this.account.user.firstname,
          name_last: this.account.user.lastname,
          email_address: this.account.user.email,
          cell_number: this.account.user.phone,
          m_payment_id: this.order.id,
          amount: parseFloat(this.order.total),
          item_name: 'Wall Art Order',
          email_confirmation: '1',
          confirmation_address: 'dehanlouw@icloud.com',
          signature: '',
        };
        if (this.isRental) {
          this.pfParams.subscription_type = 2;
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.thumbnail {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Order.vue